export default __webpack_public_path__ + "static/media/fb.0bf3ad08.svg";